import Trigger, { TriggerProps } from 'rc-trigger';
import React, { useEffect, useState } from 'react';

export type ACTriggerProps = {
  children: React.ReactNode;
  trigger?: TriggerProps['action'];
  getPopupContainer?: TriggerProps['getPopupContainer'];
  placement?: keyof typeof builtinPlacements;
  popupVisible?: boolean;
  onPopupVisibleChange?: (visible: boolean) => void;
  popup: React.ReactNode;
  offset?: number[];
  offsetX?: number;
  offsetY?: number;
  enterDelay?: number;
};

export default function ACTrigger({
  children,
  placement,
  popupVisible,
  trigger,
  onPopupVisibleChange,
  popup,
  offset: offsetFromProps,
  offsetX: offsetXFromProps = offsetFromProps?.[0] ?? 0,
  offsetY: offsetYFromProps = offsetFromProps?.[1] ?? 0,
  getPopupContainer,
  enterDelay,
}: ACTriggerProps) {
  const [offset, setOffset] = useState<ACTriggerProps['offset']>([
    offsetXFromProps,
    offsetYFromProps,
  ]);

  useEffect(() => {
    setOffset([offsetXFromProps, offsetYFromProps]);
  }, [offsetXFromProps, offsetYFromProps]);

  const child = React.Children.only(children) as React.ReactElement<any>;
  const triggerProps: TriggerProps = {
    builtinPlacements: builtinPlacements,
    popupPlacement: placement,
    action: trigger,
    popup: <div className="ac-trigger-container">{popup}</div>,
    children: child,
    popupAlign: { offset, overflow: { adjustX: true, adjustY: true } },
    getPopupContainer,
  };
  if (popupVisible !== undefined) {
    triggerProps.popupVisible = popupVisible;
  }
  if (onPopupVisibleChange !== undefined) {
    triggerProps.onPopupVisibleChange = onPopupVisibleChange;
  }
  return <Trigger {...triggerProps} mouseEnterDelay={enterDelay} />;
}

const builtinPlacements = {
  left: {
    points: ['cr', 'cl'],
  },
  right: {
    points: ['cl', 'cr'],
  },
  top: {
    points: ['bc', 'tc'],
  },
  bottom: {
    points: ['tc', 'bc'],
  },
  topLeft: {
    points: ['bl', 'tl'],
  },
  topRight: {
    points: ['br', 'tr'],
  },
  bottomRight: {
    points: ['tr', 'br'],
  },
  bottomLeft: {
    points: ['tl', 'bl'],
  },
};
